import React, { useEffect, useState } from 'react'
import { loadSelectedCover, loadCoverPosition } from '@lib/cover-unlock'

type Props = {
  userId: number
}

const CoverBanner = ({ userId }: Props) => {
  const [selectedCover, setSelectedCover] = useState<string | null>(null)
  const [coverPosition, setCoverPosition] = useState({ x: 50, y: 50 })

  // Load selected cover and position on mount
  useEffect(() => {
    const loadCoverData = async () => {
      if (userId) {
        const cover = await loadSelectedCover(userId.toString())
        if (cover) {
          setSelectedCover(cover)
        }

        const position = await loadCoverPosition(userId.toString())
        if (position) {
          setCoverPosition(position)
        }
      }
    }
    loadCoverData()
  }, [userId])

  return (
    <div className="relative h-48 md:h-64 w-full">
      {/* Cover Image with clipping */}
      <div className="absolute inset-0 overflow-hidden rounded-t-lg">
        <div className="absolute inset-0">
          <img
            src={
              selectedCover ||
              '/images/student-cover-images/student_profile_banner.png?v=2'
            }
            alt="Cover"
            className="w-full h-full object-cover"
            style={{
              objectPosition: selectedCover
                ? `${coverPosition.x}% ${coverPosition.y}%`
                : 'center center',
            }}
            loading="lazy"
          />
          {!selectedCover && (
            <div
              className="absolute inset-0 bg-black opacity-20"
              style={{ pointerEvents: 'none' }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default CoverBanner
